import { NextRouter } from 'next/router';

import { POS_PATH } from 'constants/pos';

export const isPosPage = (router: NextRouter) =>
  router.pathname.includes(POS_PATH);

export const isPosLandingPage = (router: NextRouter) =>
  router.pathname === POS_PATH;
